import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const useGridStats = () => {
  const { data, loading, error } = useQuery<
    GetGridStatsQuery,
    GetGridStatsQueryVariables
  >(GET_GRID_STATS);

  const gridStats = data?.egridSubregion;
  return { data: gridStats, error, loading };
};

const mockGridStats = {
  energyBreakdown: {
    coal: 0.2746,
    gas: 0.3513,
    nuclear: 0.1936,
    oil: 0.006,
  },
  energySummary: {
    fossilFuels: 0.6354,
    fossilFuelsAndNuclear: 0.829,
    renewables: 0.1533,
  },
};

export const useGridStatsMock = {
  data: mockGridStats,
  error: null,
  loading: false,
};

export const GET_GRID_STATS = gql`
  query GetGridStats {
    egridSubregion(abbreviation: "US") {
      energySummary {
        fossilFuels
        fossilFuelsAndNuclear
        renewables
      }
      energyBreakdown {
        gas
        coal
        oil
        nuclear
      }
    }
  }
`;

export const getGridStatsMock = {
  egridSubregion: mockGridStats,
};
